<template>
  <div class="employeeDetail">
    <div class="top" style="margin-bottom:0.1rem">
      <img src="../../../../assets/img/user/employee_icon.png" alt />
      <div class="t-content">
        <div @click="editName" style="display:flex">
          <span class="name">{{dataDetail.realname}}</span>
          <van-icon name="edit" size="0.48rem" color="#31B158" />
          <!-- <img class="edit_name" src="@/assets/img/user/user_edit.png" alt /> -->
        </div>
        <div>{{dataDetail.mobile}}</div>
        <div>{{employee_role}}</div>
      </div>
      <div></div>
    </div>
    <div style="margin-bottom:0.1rem">
      <van-cell center title="员工状态">
        <template #right-icon>
          <van-switch
            v-model="checked"
            size="24"
            :loading="loading"
            active-color="#31B158"
            @change="handleChange"
          />
        </template>
      </van-cell>
      <van-cell v-if="dataDetail.status==1" @click="toEmployeeLimit" center title="角色设置" is-link></van-cell>
    </div>

    <div v-if="dataDetail.status==2" class="btn">
      <van-button type="warning" block @click="delChange">删除</van-button>
    </div>

    <!-- 弹框提示 -->
    <van-dialog v-model="showChangeName" title="请输入名称" show-cancel-button @confirm="handleConfirm">
      <div class="showChangeName_box">
        <input type="text" v-model="listQuery.realname" placeholder="请输入10位以内的名称" />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  employee_update,
  employee_realname,
  employee_role_list,
  employee_detail
} from "@/api/work/mine/employee";
export default {
  name: "employeeDetail",
  data() {
    return {
      dataDetail: {},
      checked: false,
      loading: false,
      showChangeName: false,
      list: [],
      listQuery: { uid: "", realname: "" }
    };
  },
  computed: {
    employee_role() {
      let str = "";
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].id == this.dataDetail.role_type) {
          str = this.list[i].name;
        }
      }
      return str;
    }
  },
  created() {
    // this.dataDetail = JSON.parse(decodeURI(this.$route.query.item));
    this.listQuery.uid = this.$route.query.uid;
    this.$navigation.on("back", (to, from) => {
      if (from.route.name == "mine_employee_employeeLimit") {
        this.getList();
      }
    });
    this.getList();
    //this.listQuery.realname  = this.dataDetail.realname;
    // this.checked = this.dataDetail.status == 1;
  },
  mounted() {},
  methods: {
    // 去权限页面
    toEmployeeLimit() {
      this.$router.push({
        path: "/mine/employee/employeeLimit",
        query: {
          uid: this.listQuery.uid
        }
      });
    },
    //请求员工详情
    getList() {
      let obj = {
        uid: this.listQuery.uid
      };
      employee_detail(obj).then(res => {
        if (res.code == 200) {
          this.dataDetail = res.data;
          this.checked = res.data.status == 1;
          this.listQuery.realname = res.data.realname;
        }
      });
      if (this.list.length ==0) {
        employee_role_list().then(res => {
          if (res.code == 200) {
            this.list = res.data;
          }
        });
      }
    },
    //确定修改名字
    handleConfirm() {
      if (!this.listQuery.realname) {
        this.$toast("请输入名称！");
        return false;
      }
      if (this.listQuery.realname.length > 10) {
        this.$toast("请输入10位以内的名称！");
        return false;
      }
      employee_realname(this.listQuery).then(res => {
        if (res.code == 200) {
          this.getList();
          this.$toast.success("修改成功");
        }
      });
    },
    //修改名字
    editName() {
      this.showChangeName = true;
      this.listQuery.realname = this.dataDetail.realname;
    },
    // 修改状态
    handleChange(val) {
      this.loading = true;
      var subData = {
        uid: this.dataDetail.uid,
        role_type: this.dataDetail.role_type,
        status: val ? "1" : "2"
      };
      employee_update(subData).then(res => {
        if (res.code == 200) {
          this.loading = false;
          this.dataDetail.status = val ? "1" : "2";
          // this.$toast.success(res.message);
        }
      });
    },
    // 删除
    delChange() {
      this.$dialog
        .confirm({
          title: "提示",
          message: "确认删除该员工吗？"
        })
        .then(() => {
          var subData = {
            uid: this.dataDetail.uid,
            role_type: this.dataDetail.role_type,
            status: "-1"
          };
          employee_update(subData).then(res => {
            if (res.code == 200) {
              this.$toast.success(res.message);
              this.$router.go(-1);
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    }
  }
};
</script>

<style lang="less" scoped>
.employeeDetail {
  .name {
    display: inline-block;
    margin-right: 0.2rem;
  }
  .showChangeName_box {
    width: 90%;
    margin: 0.3rem auto;
    height: 0.8rem;
    border-radius: 0.1rem;
    border: 0.02rem solid #ccc;
    display: flex;
    align-items: center;
    justify-content: center;
    input {
      border: none;
      width: 95%;
      color: #333;
    }
  }
  .top {
    background-color: #fff;
    margin-top: 0.2rem;
    padding: 0.37rem 0.2rem;
    align-items: top;
    display: flex;
    justify-content: space-between;

    img {
      width: 0.92rem;
      height: 0.92rem;
    }
    .edit_name {
      width: 0.32rem;
      height: 0.32rem;
    }
    .t-content {
      width: 5.2rem;
      > div:first-child {
        font-size: 0.32rem;
      }
      > div:nth-child(2) {
        margin-top: 0.27rem;
        margin-bottom: 0.23rem;
      }
      > div:last-child {
        display: inline-block;
        // width: 1.52rem;
        padding: 0 0.2rem;
        line-height: 0.36rem;
        font-size: 0.24rem;
        border-radius: 0.18rem;
        background: rgba(49, 177, 88, 0.2);
        color: #31b158;
        text-align: center;
      }
    }
  }
  .btn {
    margin: 0.4rem 0.3rem;
  }
}
</style>